import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'

const BOTAbout = ({ placeholders: { content = []} = {}}) =>
  <Wrapper>
    { content }
  </Wrapper>

BOTAbout.propTypes = {
  placeholders: PropTypes.shape({
    content: PropTypes.array
  })
}

BOTAbout.type = 'BOTAbout'
BOTAbout.placeholders = ['content']

export default BOTAbout

const Wrapper = styled.div`
  ${Mixin.responsive('margin', '75px auto 40px', '15px 8px 40px')}
`
